import { useCookieConsent } from '@packages/shared';
import { useEffect } from 'react';
import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

export const Rooms3D = ({ room }: { room: string }) => {
  const isAllowed: boolean = useCookieConsent('C0004');
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (isAllowed) {
      dispatchGTMEvent({
        event: 'RenderRooms3d',
        rooms3dRoomName: room,
      });
    }
  }, [dispatchGTMEvent, isAllowed, room]);

  return isAllowed ? (
    <div data-testid={ExternalScriptTestIds.Rooms3dScript} id={`rooms-3d-${room}`} />
  ) : (
    <div data-testid={ExternalScriptTestIds.Rooms3dScriptNotAllowed} id="rooms-3d-not-allowed" />
  );
};
